// extracted by mini-css-extract-plugin
export default {"tx":"_57fc832450","line":"c4a420effd"};